export default __webpack_public_path__ + "static/media/illustration-study-1-n-w@2x.bd534366.webp";